<template>
  <validation-observer ref="simpleRules">
    <b-form>
      <b-row>
        <b-col md="6">
          <b-form-group>
            <label>VALOR TOTAL PRODUTOS</label>
            <validation-provider
                #default="{ errors }"
                rules="required"
                name="VALOR TOTAL PRODUTOS"
            >
              <b-form-input
                  v-model="$store.getters['PTC_PedidosClient/getTotalPedido'].ValorTotalPedidosImpostos"
                  :state="errors.length > 0 ? false:null"
                  placeholder="VALOR TOTAL PRODUTOS"
                  disabled
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <b-col md="6">
          <b-form-group>
            <label>QUANTIDADE TOTAL</label>
            <validation-provider
                #default="{ errors }"
                rules="required"
                name="QUANTIDADE TOTAL"
            >
              <b-form-input
                  :value="formatarNumeroInteiro($store.getters['PTC_PedidosClient/getTotalPedido'].QuantidadeTotal)"
                  :state="errors.length > 0 ? false:null"
                  placeholder="QUANTIDADE TOTAL"
                  disabled
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <b-col md="6">
          <b-form-group>
            <label>BASE IPI</label>
            <validation-provider
                #default="{ errors }"
                rules="required"
                name="BASE IPI"
            >
              <b-form-input
                  v-model="$store.getters['PTC_PedidosClient/getTotalPedido'].BaseIPITotal"
                  :state="errors.length > 0 ? false:null"
                  placeholder="BASE IPI"
                  disabled
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <b-col md="6">
          <b-form-group>
            <label>VALOR IPI</label>
            <validation-provider
                #default="{ errors }"
                rules="required"
                name="VALOR IPI"
            >
              <b-form-input
                  v-model="$store.getters['PTC_PedidosClient/getTotalPedido'].ValorIPITotal"
                  :state="errors.length > 0 ? false:null"
                  placeholder="VALOR IPI"
                  disabled
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <b-col md="6">
          <b-form-group>
            <label>BASE ICMS</label>
            <validation-provider
                #default="{ errors }"
                rules="required"
                name="BASE ICMS"
            >
              <b-form-input
                  v-model="$store.getters['PTC_PedidosClient/getTotalPedido'].BaseICMSTotal"
                  :state="errors.length > 0 ? false:null"
                  placeholder="BASE ICMS"
                  disabled
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <b-col md="6">
          <b-form-group>
            <label>VALOR ICMS</label>
            <validation-provider
                #default="{ errors }"
                rules="required"
                name="VALOR ICMS"
            >
              <b-form-input
                  v-model="$store.getters['PTC_PedidosClient/getTotalPedido'].ValorICMSTotal"
                  :state="errors.length > 0 ? false:null"
                  placeholder="VALOR ICMS"
                  disabled
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <b-col md="6">
          <b-form-group>
            <label>BASE ICMS ST</label>
            <validation-provider
                #default="{ errors }"
                rules="required"
                name="BASE ICMS ST"
            >
              <b-form-input
                  v-model="$store.getters['PTC_PedidosClient/getTotalPedido'].BaseICMSSTTotal"
                  :state="errors.length > 0 ? false:null"
                  placeholder="BASE ICMS ST"
                  disabled
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <b-col md="6">
          <b-form-group>
            <label>VALOR ICMS ST</label>
            <validation-provider
                #default="{ errors }"
                rules="required"
                name="VALOR ICMS ST"
            >
              <b-form-input
                  v-model="$store.getters['PTC_PedidosClient/getTotalPedido'].ValorICMSSTTotal"
                  :state="errors.length > 0 ? false:null"
                  placeholder="VALOR ICMS ST"
                  disabled
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <b-col md="6">
          <b-form-group>
            <label>VALOR TOTAL PEDIDOS C/ IMPOSTOS</label>
            <validation-provider
                #default="{ errors }"
                rules="required"
                name="VALOR TOTAL PEDIDOS C/ IMPOSTOS"
            >
              <b-form-input
                  v-model="$store.getters['PTC_PedidosClient/getTotalPedido'].ValorTotalPedidosImpostos"
                  :state="errors.length > 0 ? false:null"
                  placeholder="VALOR TOTAL PEDIDOS C/ IMPOSTOS"
                  disabled
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <b-col md="6">
          <b-form-group>
            <label>TOTAL PESO BRUTO</label>
            <validation-provider
                #default="{ errors }"
                rules="required"
                name="TOTAL PESO BRUTO"
            >
              <b-form-input
                  :value="formatarNumeroInteiro($store.getters['PTC_PedidosClient/getTotalPedido'].PesoBrutoTotal)"
                  :state="errors.length > 0 ? false:null"
                  placeholder="TOTAL PESO BRUTO"
                  disabled
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <b-col md="6">
          <b-form-group>
            <label>TOTAL PESO CUBADO</label>
            <validation-provider
                #default="{ errors }"
                name="TOTAL PESO CUBADO"
                rules="required"
            >
              <b-form-input
                  :value="formatarNumeroInteiro($store.getters['PTC_PedidosClient/getTotalPedido'].PesoCubadoTotal)"
                  :state="errors.length > 0 ? false:null"
                  placeholder="TOTAL PESO CUBADO"
                  disabled
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
      </b-row>
    </b-form>
  </validation-observer>
</template>
<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import {
  BFormInput, BFormGroup, BForm, BRow, BCol, BButton,
} from 'bootstrap-vue';

export default {
  name: 'total-pedido',
  components: {
    ValidationProvider,
    ValidationObserver,
    BFormInput,
    BFormGroup,
    BForm,
    BRow,
    BCol,
    BButton,
  },

  data() {
    return {
      form: {
        valor_total_produtos: '',
        qtd_total: '',
        dase_ipi: '',
        valor_ipi: '',
        base_icms: '',
        valor_icms: '',
        base_icms_st: '',
        valor_icms_st: '',
        valor_total_pedidos_impostos: '',
        total_peso_bruto: '',
        total_peso_cubado: '',
      },
    };
  },

  methods: {
    formatarNumeroInteiro(valor) {
      if (!valor && valor !== 0) return '';

      const numero = parseFloat(valor);

      if (Number.isInteger(numero)) {
        return numero.toString();
      }

      return numero.toString();
    },
    validationForm() {
      this.$refs.simpleRules.validate().then((success) => {
        if (success) {
          // eslint-disable-next-line
          alert('form submitted!')
        }
      });
    },
  },

};
</script>
<style scoped lang="scss">

</style>
